import {combine} from 'effector';

import {fetchDocumentProductsGrid} from 'api';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {ProductContentRawRow} from 'types';

const domain = rootDomain.createDomain('DocumentsProductTableDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchDocumentProductsGrid,
});
export const fetchTotalCountFx = domain.createEffect({
    name: 'fetchTotalCountFx',
    handler: fetchDocumentProductsGrid,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    Gate,
    tableStateChanged,
    tableStateCacheChanged,
    stateReset,
} = createGridTableModel({
    domain,
});

export const data$ = domain.createStore<{
    nextPageRef: string;
    data: ProductContentRawRow[];
} | null>(null);
export const totalCount$ = domain.createStore<number>(0);

export const gridCacheReset = domain.createEvent();
export const gridTokensCache$ = domain.createStore<Record<number, string | null>>({0: null});

export const state$ = combine({
    data: data$,
    totalCount: totalCount$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    pageNumberChanged,
    filters: filters$,
    sortings: sortings$,
    gridTokensCache: gridTokensCache$,
    isLoading: fetchDataFx.pending || fetchTotalCountFx.pending,
});
